<template>
	<div class="card-wrapper" :style="cardElementStyles">
		<!-- Special Status display info -->
		<div v-if="cardNegativeStatusMapper(params.status) || params.unblockable" class="screen"/>
		<lock-icon class="special-status-icon" v-if="params.unblockable"/>
		<alert-icon class="special-status-icon" v-if="cardNegativeStatusMapper(params.status)"/>
		<!-- Card Mini Text -->
		<span v-if="!(cardNegativeStatusMapper(params.status) || params.unblockable)">{{cardImageTextCreator(productName)}}</span>
	</div>
</template>

<script setup>
import LockIcon from '@/assets/icons/lock.svg?inline'
import AlertIcon from '@/assets/icons/warning.svg?inline'
/* Vue */
import { computed } from 'vue'
/* Aux */
import { HEADER_GRADIENTS } from '@/assets/constants/core'
import { cardImageTextCreator, cardClassCreator } from '@/assets/scripts/mappers/cards'
import { cardNegativeStatusMapper } from '@/assets/scripts/mappers/cards'

/** props received
@productName { String }
@params { Object }
	- id {Number, String}
	- type {String}
	- productName {String}
	- product {String}
	- status {String} - code of card status
	- statusDescriptive {String} - description of current status
	- blockable {Boolean} - if card can be blocked, it means the card is currently unblocked
	- unblockable {Boolean} - if card can be unblocked, it means the card is currently blocked
*/
const props = defineProps({
	productName: String,
	params: Object
})

const cardElementStyles = computed(() => {
	let gradient = HEADER_GRADIENTS['generic-card-background-color']
    if (HEADER_GRADIENTS[`${cardClassCreator(props.productName)}-background-color`]) gradient = HEADER_GRADIENTS[`${cardClassCreator(props.productName)}-background-color`]

	return {
        'background-color': `var(${gradient})`
	}
})
</script>

<style lang="scss" scoped>
.card-wrapper {
	width: 56px;
	height: 32px;

	display: flex;
	flex-shrink: 0;
	align-items: center;
	justify-content: center;
	position: relative;

	border-radius: 4px;

	@include H9-Regular;
    text-transform: capitalize;
	color: var(--secondary-light-4); // we want this color independent from themes

	.screen {
		width: 100%;
		height: 100%;

		border-radius: 6px;

		background-color: var(--secondary-dark-4);
		opacity: 0.5;
	}

	svg.special-status-icon {
		width: 20px;
		height: 20px;

		position: absolute;

        :deep(.change-color-fill) {
            fill: var(--secondary-light-4);
        }
	}
}
</style>
